import { FetchResponse, FetchSuccess } from '../types';
import {
  DefaultFetchError,
  FetchGet,
  FetchUpdate,
  useFetchGet,
  useFetchUpdate,
} from './fetch';

export type MbsMarketAlert = {
  id: number;
  increaseAlertEnabled: boolean;
  increaseThreshold: number;
  decreaseAlertEnabled: boolean;
  decreaseThreshold: number;
  lastIncreaseAlertDate: Date;
  lastDecreaseAlertDate: Date;
}

export type MbsMarketAlertForm = {
  increaseAlertEnabled: boolean;
  increaseThreshold: number;
  decreaseAlertEnabled: boolean;
  decreaseThreshold: number;
}

export const useMbsMarketAlert = (): FetchGet<FetchResponse<MbsMarketAlert>> =>
  useFetchGet('mbs-market-alerts', {
    autoStart: false,
    startStateLoading: false,
  });

export const useUpdateMbsMarketAlert = (): FetchUpdate<
  FetchSuccess,
  DefaultFetchError,
  MbsMarketAlertForm
> => useFetchUpdate('mbs-market-alerts', '');
